import { isMacOs } from 'react-device-detect';
import Box from '@mui/material/Box';
import { PropTypes } from 'prop-types';
import { Row, IconButton } from '@livechat/ui-kit';
import { ChatWrapperCss as WrapperCss } from '../../utils/WrapperCss';
import ProgressBar from './ProgressBar';
import {
  CANCEL_THIS_PROCESS_ENG,
  CANCEL_THIS_PROCESS_ESP,
  END_CHAT_ENG,
  END_CHAT_ESP,
  END_CHAT_FEEDBACK_ENG,
  END_CHAT_FEEDBACK_ESP,
  REGISTER_AS_CUSTOMER_ENG,
  REGISTER_AS_CUSTOMER_ESP,
} from '../../Constants';
import { CommonStyles as CommoncssStyles } from '../../styles/ChatBotCommonStyles';

const ValidationProcess = (props) => {
  const {
    englishBot,
    runningAWSConnect,
    showUploadingBar,
    liveAgentJoined,
    isFeedbackProcess,
    setAgentFeedbackTrigger,
    onCancelProcessHandler,
    isValid,
    isCancelProcess,
    errorMessage,
    waitingForLiveAgent,
    setServiceFormTrigger,
    formInProcessTrigger,
    showRegisterCustomerButton,
  } = props;

  const registerCustomer = () => {
    setServiceFormTrigger(true);
    formInProcessTrigger(true);
  };
  return (
    <>
      {isFeedbackProcess && runningAWSConnect && !showUploadingBar && liveAgentJoined && (
        <Box
          component="div"
          sx={isFeedbackProcess ? WrapperCss.cancelBtnDisplay : WrapperCss.cancelBtnNoDisplay}
        >
          <Row align="center" className={CommoncssStyles.validation_design}>
            {showRegisterCustomerButton && (
              <IconButton
                data-testid="validation_id"
                sx={`cancel-process-btn ${
                  isMacOs ? WrapperCss.button_width_IOS : WrapperCss.button_width_Windows
                }`}
                onClick={registerCustomer}
                aria-label={englishBot ? REGISTER_AS_CUSTOMER_ENG : REGISTER_AS_CUSTOMER_ESP}
                tabIndex="104"
              >
                {englishBot ? REGISTER_AS_CUSTOMER_ENG : REGISTER_AS_CUSTOMER_ESP}
              </IconButton>
            )}
            <IconButton
              sx={`cancel-process-btn ${
                isMacOs ? WrapperCss.button_width_IOS : WrapperCss.button_width_Windows
              }`}
              onClick={setAgentFeedbackTrigger}
              aria-label={englishBot ? END_CHAT_FEEDBACK_ENG : END_CHAT_FEEDBACK_ESP}
              tabIndex="104"
            >
              {englishBot ? END_CHAT_ENG : END_CHAT_ESP}
            </IconButton>
          </Row>
        </Box>
      )}
      <Box
        component="div"
        sx={
          isValid && isCancelProcess ? WrapperCss.cancelBtnDisplay : WrapperCss.cancelBtnNoDisplay
        }
      >
        <Row align="center" className={CommoncssStyles.validation_design}>
          <IconButton
            sx={`cancel-process-btn ${
              isMacOs ? WrapperCss.button_width_IOS : WrapperCss.button_width_Windows
            }`}
            onClick={onCancelProcessHandler}
            aria-label={englishBot ? CANCEL_THIS_PROCESS_ENG : CANCEL_THIS_PROCESS_ESP}
            data-testid="onCancelProcessHandler_testid"
            tabIndex="104"
            disabled={waitingForLiveAgent}
          >
            {englishBot ? CANCEL_THIS_PROCESS_ENG : CANCEL_THIS_PROCESS_ESP}
          </IconButton>
        </Row>
      </Box>
      <ProgressBar runningAWSConnect={runningAWSConnect} showUploadingBar={showUploadingBar} />
      <Box
        component="div"
        sx={isValid ? WrapperCss.errorMessageNoDisplay : WrapperCss.errorMessageDisplay}
      >
        <Row align="center" className={CommoncssStyles.validation_align}>
          <span role="alert">{errorMessage}</span>
        </Row>
      </Box>
    </>
  );
};

ValidationProcess.propTypes = {
  englishBot: PropTypes.bool,
  runningAWSConnect: PropTypes.bool,
  showUploadingBar: PropTypes.bool,
  liveAgentJoined: PropTypes.bool,
  isFeedbackProcess: PropTypes.bool,
  setAgentFeedbackTrigger: PropTypes.func,
  onCancelProcessHandler: PropTypes.func,
  isValid: PropTypes.bool,
  isCancelProcess: PropTypes.bool,
  errorMessage: PropTypes.string,
  waitingForLiveAgent: PropTypes.bool,
  setServiceFormTrigger: PropTypes.func,
  formInProcessTrigger: PropTypes.func,
  showRegisterCustomerButton: PropTypes.bool,
};

export default ValidationProcess;
